<template>
  <div>
    <h1 class="form-title font-medium text-2xl">{{ form.title }}</h1>
    <p class="form-description mt-2">{{ form.description }}</p>
  </div>
</template>

<script>
export default {
  name: "FormHeader",
  props: ["form"]
};
</script>
